import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import AuthLayout from 'layouts/AuthLayout'
import TwoFactorVerify from 'components/PageComponents/Auth/TwoFactorVerify'

const TwoFactorVerifyPage = () => (
  <>
    <Helmet>
      <title>Skefto: Two-Factor Verification</title>
    </Helmet>
    <AuthLayout>
      <TwoFactorVerify />
    </AuthLayout>
  </>
)

export default TwoFactorVerifyPage
